import React from "react"
import { Link } from "gatsby"
import Nav from "./nav"

const Header = () => (
  <>
    <Nav
      prefix={
        <span className="flex mr-4">
          <h1 className="mr-2">
            <Link
              className="text-base uppercase leading-none hover:text-cyan tracking-tight"
              to="/"
            >
              Alvin Crespo
            </Link>
          </h1>
          <span>{`//`}</span>
        </span>
      }
    />
  </>
)

export default Header
